import gql from 'graphql-tag'

const VARIANCE_GRAPH_QUERY = gql`
  query VarianceGraphQuery($videoId: ID!) {
    node(id: $videoId) {
      __typename
      ... on Video {
        id

        fragments {
          highlightScore
          startTime
          endTime
        }
      }
    }
  }
`

export default VARIANCE_GRAPH_QUERY



// WEBPACK FOOTER //
// ./src/components/VarianceGraph.query.js